import { ScamTypeKey } from "./cvtiToScamType"; // 필요에 따라 경로 조정

export const scamTypeIcons: Record<ScamTypeKey, string> = {
  감정공감형: "😍",
  절차맹신형: "📮",
  직진반응형: "⚡",
  실험과잉형: "🧪",
  신뢰우선형: "🤝",
  회피수동형: "🙈",
  정보과신형: "🧠",
  선한낙관형: "🌞",
  무관심형: "😐",
};
